<template>
  <div class="flex flex-col h-screen transition-fade">
    <div 
    v-if="menu.layout != 'frydate'"
    :class="['flex items-center justify-center']"
      :style="welcomeHeaderHeight + kioskHeaderBackground"
    >
      <div>
        <img
          class="h-40 object-cover"
          :src="
            menu.picture_url
              ? menu.picture_url
              : require('../assets/images/Menu.Logo.png')
          "
          :style="welcomeLogoHeight"
          alt="Logo"
        />
      </div>
      <div v-if="!menu.picture_url" class="text-2xl text-white ml-6">
        <p>QR MENU APP</p>
        <p class="text-5xl"
        :style="makeStyles(titleFont,titleTextTransform)"
        >
        {{ menu["name" + "_" + language] }}
      </p>
    </div>
  </div>
    <div
      :class="['rounded-t-xxl w-screen px-4 flex flex-col justify-center items-center self-center flex-1 bg-cover',
      menu.layout == 'frydate' ? 'relative justify-center' : '',
      ]"
      :style="makeStyles(mainSectionTopRadius , kioskBackgroundMainScreen)"
      >
      
        <div
          class="mb-8 text-3xl text-product-gray font-bold"
          :style="kioskEatTodayTextDisplay + kioskMainText"
        >
          {{ lang["what_to_eat"][this.language] }}
        </div>
        <div :class="['flex mb-20', verticalOrderTypeButtonLayout == 'true'? 'flex-col w-4/5 gap-16' : '']">
          <button
            v-for="(type, i) in orderTypes"
            :key="i"
            v-if="type == 'take_away' ? menu.is_kiosk_take_away_enabled : menu.is_kiosk_dine_in_enabled"
            @click="setOrderType(type)"
            :class="[
              'bg-primary-100 text-new-primary font-bold text-center text-3xl flex flex-col justify-center items-center rounded-xl',
              orderTypeButtonShadow == 'true' ? 'shadow-2xl' : '',
              orderTypes.length - 1 !== i && 'mr-8',
              menu.hide_kiosk_icon_text?'py-20':'py-24',
              verticalOrderTypeButtonLayout == 'true' ? 'h-64 w-full' : 'w-64',
              menu.layout == 'frydate' ? 'h-64' : '',
            ]"
            :style="makeStyles( kioskLandingPageCardRadius, titleFont , titleTextTransform, kioskStartBackgroundButton , textKioskHomepageColor, orderTypeButtonOpacity)"
          >
            <OrderTypeIcons
              :type="type"
              class="mb-4"
              :color="iconKioskHomepageColor"
              :size="imageWidth"
              :opacity="orderTypeButtonOpacity"
            />
            <template v-if="!menu.hide_kiosk_icon_text&&menu[`${type}_title_${language}`]">
              {{ menu[`${type}_title_${language}`] }}
            </template>
            <template v-else-if="!menu.hide_kiosk_icon_text&&lang[type]">
              {{ lang[type][language] }}
            </template>
            <template v-else-if="!menu.hide_kiosk_icon_text">
              {{ type }}
            </template>
          </button>
        </div>
        <div>
          <div
            :class="['flex flex-col gap-4 items-center justify-center', 
            menu.layout == 'frydate' ? 'absolute top-0 right-0 p-12' : '',
            ]"
          >
            <button
              v-if="menu.hasNL || menu.language == 'nl'"
              :class="[
                'border-b-1.5 p-2 px-3 flex cursor-pointer ml-3 mr-3 border-1.5 rounded-xl items-center text-xl',
                language == 'nl'? 'text-2xl' : ''
                ]"
              :style="makeStyles(hasKiosk&&languageButtonRadius,languageButtonBackground,language == 'nl'? selectedLanguageButtonBackground : '')" 
              @click="
                updateLanguage('nl');
              "
            >
              <img 
              :class="['w-8 h-8 mr-4', language == 'nl'? 'w-10 h-10': '']" 
              src="../assets/images/flags/nether.png" />
              <p class="text-product-gray font-semibold" :style="languageButtonTextColor">Nederlands</p>
            </button>
            <button
              v-if="menu.hasEN || menu.language == 'en'"
              :class="[
                'border-b-1.5 p-2 px-3 flex cursor-pointer ml-3 mr-3 border-1.5 rounded-xl items-center text-xl',
                language == 'en'? 'text-2xl' : ''
                ]"
              :style="makeStyles(hasKiosk&&languageButtonRadius,languageButtonBackground,language == 'en'? selectedLanguageButtonBackground : '')" 
              @click="
                updateLanguage('en');
              "
            >
              <img 
              :class="['w-8 h-8 mr-4', language == 'en'? 'w-10 h-10': '']" 
              src="../assets/images/flags/engels.png" />
              <p class="text-product-gray font-semibold" :style="languageButtonTextColor">English</p>
            </button>
            <button
              v-if="menu.hasFR || menu.language == 'fr'"
              :class="[
                'border-b-1.5 p-2 px-3 flex cursor-pointer ml-3 mr-3 border-1.5 rounded-xl items-center text-xl',
                language == 'fr'? 'text-2xl' : ''
                ]"
              :style="makeStyles(hasKiosk&&languageButtonRadius,languageButtonBackground,language == 'fr'? selectedLanguageButtonBackground : '')" 
              @click="
                updateLanguage('fr');
              "
            >
              <img 
              :class="['w-8 h-8 mr-4', language == 'fr'? 'w-10 h-10': '']" 
              src="../assets/images/flags/france.png" />
              <p class="text-product-gray font-semibold" :style="languageButtonTextColor">Français</p>
            </button>
            <button
              v-if="menu.hasDE || menu.language == 'de'"
              :class="[
                'border-b-1.5 p-2 px-3 flex cursor-pointer ml-3 mr-3 border-1.5 rounded-xl items-center text-xl',
                language == 'de'? 'text-2xl' : ''
                ]"
              :style="makeStyles(hasKiosk&&languageButtonRadius,languageButtonBackground,language == 'de'? selectedLanguageButtonBackground : '')" 
              @click="
                updateLanguage('de');
              "
            >
              <img 
              :class="['w-8 h-8 mr-4', language == 'de'? 'w-10 h-10': '']" 
              src="../assets/images/flags/germany.png" />
              <p class="text-product-gray font-semibold" :style="languageButtonTextColor">Deutsch</p>
            </button>
          </div>
        </div>
    </div>
    <transition name="slide-fade">
          <modal
            name="comoMember"
            class="roundedmodal"
            transition="slide-fade"
            width="90%"
            :maxWidth="680"
            height="auto"
            :adaptive="true"
            scrollable
          >
            <div class="mt-3 flex justify-between">
              <a @click.prevent="$modal.hide('comoMember')">
                <!-- <IconCancel
                /> -->
              </a>
              <h1
                class="w-full text-center mb-4 ml-2 text-product-gray font-bold text-2xl justify-center pt-4"
              >
                Do you have the membership?
              </h1>
            </div>
            <div class="pl-8 pr-8 pb-8">
              <div class="flex justify-center">
            
                <button
                  @click="$modal.show('comoScan')"
                  :class="[
                    'bg-primary-100 w-64 text-new-primary font-bold text-center text-5xl flex flex-col justify-center items-center rounded-xl mr-8 py-20',
                  ]"
                  :style="makeStyles( kioskLandingPageCardRadius, titleFont , titleTextTransform, kioskStartBackgroundButton , textKioskHomepageColor)"
                >
                Yes
                <div class="text-3xl">
                  Scan QR Code
                </div>
                </button>
                <button
                  @click="closeComoMember"
                  :class="[
                    'bg-primary-100 w-64 text-new-primary font-bold text-center text-5xl flex flex-col justify-center items-center rounded-xl py-20',
                  ]"
                  :style="makeStyles( kioskLandingPageCardRadius, titleFont , titleTextTransform, kioskStartBackgroundButton , textKioskHomepageColor)"
                >
                No
                <div class="text-3xl">
                  Continue to app
                </div>
                </button>
              </div>
            </div>
          </modal>
    </transition>
    <transition name="slide-fade-reverse">
    <modal
      name="comoScan"
      transition="slide-fade-reverse"
      :adaptive="true"
      scrollable
      class="comoScanModal"
      > 
      <ComoScanner :orderType="selectedOrderType"/>
    </modal>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import _ from 'lodash';
// import IconCancel from "../components/icons/iconCancel.vue";
import ComoScanner from "./ComoScanner";

// import LanguageModal from "../components/LanguageModal";
import OrderTypeIcons from "../components/OrderTypeIcons.vue";

import lang from "../lang";
// import { saveNewSessionId } from "../utils";

const orderTypes = ["dine_in", "take_away"];

export default {
  data() {
    return {
      lang,
      orderTypes,
      showQRCodeScanner: false,
      scannedData: '',
      scannerLoading: false,
      scanError: false,
      selectedOrderType: null,
      imageWidth: 0,
    };
  },
  components: {
    OrderTypeIcons,
    ComoScanner
  },
  computed: {
    ...mapGetters([
      "identificationFormData",
      "language",
      "menu",
      "menuCategories",
      "currentHash",
      "idleTimer",
      "hasKiosk",
      "menuCategories",
      "sessionId",
      "member"
    ]),
    ...mapGetters("Theme", [
      "titleFont",
      "titleTextTransform",
      "languageButtonRadius",
      "mainSectionTopRadius",
      "kioskLandingPageCardRadius",
      "kioskStartBackgroundButton",
      "iconKioskHomepageColor",
      "textKioskHomepageColor",
      "kioskEatTodayTextDisplay",
      "customThemeVariables",
      "kioskBackgroundMainScreen",
      "kioskMainText",
      "welcomeHeaderHeight",
      "welcomeLogoHeight",
      "orderTypeButtonShadow",
      "selectedLanguageButtonBackground",
      "verticalOrderTypeButtonLayout",
      "orderTypeIconSize",
      "languageButtonBackground",
      "orderTypeButtonOpacity",
      "languageButtonTextColor",
      "kioskHeaderBackground"
    ]),
    isHeaderShown() {
      return !(
        !!this.customThemeVariables["welcome-header--height"] == false ||
        this.customThemeVariables["welcome-header--height"] == "0px"
      );
    }
  },
  mounted() {
     this.$store.dispatch('CREATE_NEW_SESSION_ID')
    sessionStorage.removeItem("comoMember");
    sessionStorage.removeItem("comoMemberCode");
    sessionStorage.setItem("isLoyaltyMember",false);
    // remember the printer ip in the localstorage
    if (this.$route.query.printerIp) {
      localStorage.setItem("printerIp", this.$route.query.printerIp);
    }
  },
  methods: {
            // change the value in the store
        changeLanguage(event) {
            this.$store.commit("changeLanguage", event.target.value);
        },
        // update the language for kiosk
        updateLanguage(language) {
            let currentKioskMode = localStorage.getItem("kioskOption");
            if (currentKioskMode == lang["take_away"][this.language]) {
                this.$store.commit("changeLanguage", language);
                localStorage.setItem("kioskOption", lang["take_away"][this.language]);
            }
            else {
                this.$store.commit("changeLanguage", language);
                localStorage.setItem("kioskOption", lang["dine_in"][this.language]);
            }
        },

    // add the option you choose to the localstorage with the
    addLocalstorage(value) {
      localStorage.setItem("kioskOption", value[this.language]);
      // this.$store.commit(
      //   "updateSessionId",
      //   sessionStorage.getItem("sessionId")
      // );
    },
    // get the menu categories and push the router to the correct path
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
    // take_away || dine_in
    setOrderType(type) {
      this.selectedOrderType = type
      if (this.menu.is_loyalty_enabled) {
        this.$modal.show("comoMember")
      }
      else {
        if (type === "take_away") this.$store.commit("Cart/updateHomeDelivery");
        this.$router.push({
          path: `/${this.currentHash}/sub/category/${this.menuCategories[0].Id}`,
          query:this.$route.query
        });
        this.getCategories(this.menuCategories[0]);
        this.$store.commit("updateCurrentKioskMode", lang[type][this.language]),
          this.$store.commit("updateCancelOrder", false);
        this.$store.commit("Cart/updateIsOrderTypeDineIn", type === "dine_in");
        this.addLocalstorage(lang[type]);
      }
    },
    closeComoMember() {
      sessionStorage.setItem("isLoyaltyMember",false);
      let type = this.selectedOrderType
      this.$modal.hide("comoMember")
      if (type === "take_away") this.$store.commit("Cart/updateHomeDelivery");
      this.$router.push({
        path: `/${this.currentHash}/sub/category/${this.menuCategories[0].Id}`,
        query:this.$route.query
      });
      this.getCategories(this.menuCategories[0]);
      this.$store.commit("updateCurrentKioskMode", lang[type][this.language]),
        this.$store.commit("updateCancelOrder", false);
      this.$store.commit("Cart/updateIsOrderTypeDineIn", type === "dine_in");
      this.addLocalstorage(lang[type]);
    }
  },
  created() {
    this.imageWidth = this.orderTypeIconSize != '' ? this.orderTypeIconSize : '4rem'
    // this.$store.dispatch('CREATE_NEW_SESSION_ID')
    sessionStorage.removeItem("comoMember");
    sessionStorage.removeItem("comoMemberCode");
    sessionStorage.setItem("isLoyaltyMember",false);
    // upates the menuhash
    this.$store.commit("updateMenuHash", this.$route.params.menuHash);
    this.$store.commit("updateCurrentHash", this.$route.params.menuHash);
    // if there is no menu dispatch the menu items to get one
    if (!this.menu.Id) {
      this.$store.dispatch("GET_MENU_ITEMS");
    }
    sessionStorage.removeItem("orderChunksExists");
    // saveNewSessionId("KioskStart > created:162");
  },
  updated() {
    this.imageWidth = this.orderTypeIconSize != '' ? this.orderTypeIconSize : '4rem'
    if (!this.language) {
      this.$store.commit("changeLanguage", this.menu.language);
    }
  },
};
</script>

<style>
</style>
